module.exports = __webpack_public_path__ + "static/logo-perkebunan-nusantara-f7a1b8648f870dbe89d614b01dc678db.png";